var map = {
	"./a.mp4": "fbf4",
	"./es.mp4": "413b",
	"./hb.mp4": "3285",
	"./hk.mp4": "a8cd",
	"./kk.mp4": "8e45",
	"./ma.mp4": "e82f",
	"./nol.mp4": "7831",
	"./rg.mp4": "0d0b",
	"./top-video.mp4": "8b91",
	"./video1.mp4": "84c6",
	"./video2.mp4": "7c81",
	"./video3.mp4": "5a8f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7bc1";